import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'cwt.translations.SinkPage.Title',
    defaultMessage: 'Sink',
  },
  pageDescription: {
    id: 'cwt.translations.SinkPage.Description',
    defaultMessage: 'Kitchen sinks are some of the busiest working parts of any kitchen. What do you want out of yours?',
  },
  materialDescription: {
    id: 'cwt.translations.SinkPage.Material.Description',
    defaultMessage: 'IKEA offers a great selection of sinks. Let\'s narrow it down by selecting a material first.',
  },
  modelDescription: {
    id: 'cwt.translations.SinkPage.Model.Description',
    defaultMessage: 'Before choosing a sink, think about the workflow of your kitchen and the types of tasks you often do. Whether it\'s a lot of food preparation, handwashing glassware or just giving your plates a quick rinse before the dishwasher, we\'ve got a sink to suit your needs.',
  },
  fasteningDescription: {
    id: 'cwt.translations.SinkPage.Fastening.Description',
    defaultMessage: 'Available options are limited by sink and material selection. Underglued sinks create an uninterrupted look and make cleaning your benchtop easy.',
  },
  drainerGroovesDescription: {
    id: 'cwt.translations.SinkPage.DrainerGrooves.Description',
    defaultMessage: 'If you choose an inset sink to your quartz or acrylic worktop, you also have the option to add drainer grooves to it.',
  },
  tapHolesDescription: {
    id: 'cwt.translations.SinkPage.TapHoles.Description',
    defaultMessage: 'Choose how many tap holes you need. If you have chosen a sink without space for a water tap, we’ve added one tap-hole automatically. You can add additional tap holes for soap dispensers, multiple hole taps, cookers and other sink accessories.',
  },
  cutoutForWaterTap: {
    id: 'cwt.translations.SinkPage.CutoutForWaterTap',
    defaultMessage: 'Cut-out for water tap',
  },
  didYouKnowSubtitle: {
    id: 'cwt.translations.DidYouKnow.Placement.Subtitle',
    defaultMessage: 'Sink placement',
  },
  didYouKnowDescription: {
    id: 'cwt.translations.DidYouKnow.Placement.Description',
    defaultMessage: 'An IKEA co-worker will help you choose the exact location of your sink when placing the order in one of our IKEA stores.',
  },
});
